import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSingleEffect } from 'react-haiku';
import { useCollect, useRequest } from 'hooks';

import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';

import { Button } from 'components/Misc/Form';
import { useBlankCourseStore } from 'store/blank/useBlankCourseStore';

import Add from 'containers/Administrator/Blanks/Profile/Coursez/Add';
import Overlay from 'containers/Administrator/Blanks/Profile/Coursez/Overlay';
import Droppable from 'containers/Administrator/Blanks/Profile/Coursez/Droppable';
import Draggable from 'containers/Administrator/Blanks/Profile/Coursez/Draggable';

// Schedule groups by month
const SCHEDULE = [
	{ order: 0, title: 'Nesagrupēts' },
	{ order: 1, title: 'Septembris' },
	{ order: 2, title: 'Oktobris' },
	{ order: 3, title: 'Novembris' },
	{ order: 4, title: 'Decembris' },
	{ order: 5, title: 'Janvāris' },
	{ order: 6, title: 'Februāris' },
	{ order: 7, title: 'Marts' },
	{ order: 8, title: 'Aprīlis' },
	{ order: 9, title: 'Maijs' }
];

const Coursez = ({ tab, setTab }) => {
	// Store subject's id
	const { id } = useParams();

	// Update selected tab
	useSingleEffect(() => setTab(tab));

	// Store request parameters
	const parameters = useMemo(() => ({
		eager: 'subject',
		condition: 'courses'
	}), []);

	// Store requested courses
	const [[result, progress], collect] = useCollect(`blanks/${id}`, parameters);

	// Store put request
	const [[updateProgress], update] = useRequest('put', `blanks/${id}`);

	// Use blank's courses store
	const [courses, edited, onUpdate, onInit, onReset] = useBlankCourseStore(state => [
		state.courses,
		state.edited,
		state.onUpdate,
		state.onInit,
		state.onReset
	]);

	// Store actively dragged course's id
	const [active, setActive] = useState(null);

	// Handle drag start
	const onDragStart = (event) => {
		setActive(event.active.id);
	};

	// Handle drag end
	const onDragEnd = (event) => {
		// Reset active course
		setActive(null);

		// Update course order
		onUpdate(event.active.id, event.over.id);
	};

	// Handles form's onSubmit event
	// @event: object | onSubmit event
	const onSubmit = async (event) => {
		event.preventDefault();

		// Do not submit if request in progress
		if (progress) return;

		// Try to update blank
		await update(courses, { related: 'courses' });
	};

	// Collect courses on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// Initialize course's data after collection
	useEffect(() => {
		if (result) onInit(result);

		// Reset course's data on unmount
		return () => onReset();
	}, [result]);

	return (
		<div className="mt-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors">
			<Add />
			
			<DndContext onDragStart={onDragStart} onDragEnd={onDragEnd} modifiers={[restrictToVerticalAxis]}>
				<div className="flex flex-col">
					{SCHEDULE.map(group =>
						<Droppable key={group.order} group={group}>
							{courses.filter(course => course.order === group.order).map(course =>
								<Draggable key={course.id} course={course} />
							)}
						</Droppable>
					)}
				</div>
				
				{/* Draggable overlay */}
				<Overlay active={active} />
			</DndContext>

			{/* Show controls if not progress */}
			<div className="flex justify-end p-4">
				<Button
					icon="done"
					theme="success"
					value="Saglabāt"
					disabled={!edited}
					progress={updateProgress}
					onClick={onSubmit}
				/>
			</div>
		</div>
	);
};

// const Multiple = () => {
// 	const [items, setItems] = useState([1, 2, 3]);

// 	const onDragEnd = ({ active, over }) => {
// 		const activeIdx = items.indexOf(active.id);
// 		const overIdx = items.indexOf(over.id);
// 		setItems(items => arrayMove(items, activeIdx, overIdx));
// 	};

// 	return (
// 		<DndContext onDragEnd={onDragEnd}>
// 			<SortableContext
// 				items={items}
// 				strategy={verticalListSortingStrategy}
// 			>
// 				{items.map(item => <Sortable key={item} id={item} />)}
// 			</SortableContext>
// 		</DndContext>
// 	);
// };

// const Sortable = ({ id }) => {
// 	const {
// 		attributes,
// 		listeners,
// 		setNodeRef,
// 		transform,
// 		transition
// 	} = useSortable({ id });

// const style = {
// 	transform: CSS.Transform.toString(transform),
// 	transition
// };

// 	return (
// 		<div ref={setNodeRef} {...attributes} {...listeners} style={style} className="p-2 border rounded-md">
// 			{id}
// 		</div>
// 	);
// };

export default Coursez;